/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Item_RemoveInputs */

const vi_pdc_item_remove = /** @type {(inputs: Pdc_Item_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa dòng`)
};

/**

* @param {Pdc_Item_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_item_remove = /** @type {((inputs?: Pdc_Item_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Item_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_item_remove(inputs)
});